import { ready } from '@titanio/utils'

import app from '@config/app'
import router from '@config/router'
import tracking from '@modules/tracking'

ready(() => {
  setTimeout(app.loader(), 0)
  setTimeout(router.loader(), 0)
  setTimeout(tracking.loader(), 0)
})
